//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components
import StateSelectorComponent from '../conditional-components/state-selector-component'
import CountrySelectorComponent from '../conditional-components/country-selector-component'

//// Carbon Components
import {
    Select,
    SelectItem,
    DatePicker,
    DatePickerInput,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalRegisteredNursingExaminationHistoryComponent = ({
    number,
    handleData,
    handleSubtractAdditionalExaminationHistoryComponent,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <h4>Additional Examination:</h4>

            <Select
                className="required"
                defaultValue={
                    formsData?.[digital_name]?.values?.['EXAM' + number]
                }
                value={formsData?.[digital_name]?.values?.['EXAM' + number]}
                helper=""
                labelText="Examination:"
                id={'EXAM' + number}
                name={'EXAM' + number}
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.['EXAM' + number]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'EXAM' + number + 'ErrMsg'
                    ]
                }
            >
                <SelectItem text="Choose an option" value="" />
                <SelectItem text="RN" value="RN" />
                <SelectItem text="LPN" value="LPN" />
            </Select>

            <CountrySelectorComponent
                digital_name={digital_name}
                value_key={['COUNTRY' + number]}
                state_value_key={['STATE' + number]}
                county_value_key={''}
            />

            <StateSelectorComponent
                digital_name={digital_name}
                value_key={['STATE' + number]}
                country={
                    formsData?.[digital_name]?.values?.['COUNTRY' + number]
                }
            />

            <DatePicker
                dateFormat="m/d/Y"
                datePickerType="single"
                onChange={(e) => handleData(e, ['EXMDATE' + number])}
                onClose={(e) => handleData(e, ['EXMDATE' + number])}
                value={formsData?.[digital_name]?.values?.['EXMDATE' + number]}
            >
                <DatePickerInput
                    className="required"
                    labelText="Examination Date:"
                    id={'EXMDATE' + number}
                    name={'EXMDATE' + number}
                    placeholder="MM/DD/YYYY"
                    type="text"
                    invalid={
                        formsData?.[digital_name]?.errors?.['EXMDATE' + number]
                    }
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            'EXMDATE' + number + 'ErrMsg'
                        ]
                    }
                />
            </DatePicker>

            <Select
                className="required"
                defaultValue={
                    formsData?.[digital_name]?.values?.['RESULT' + number]
                }
                value={formsData?.[digital_name]?.values?.['RESULT' + number]}
                helper=""
                labelText="Result:"
                id={'RESULT' + number}
                name={'RESULT' + number}
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.['RESULT' + number]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'RESULT' + number + 'ErrMsg'
                    ]
                }
            >
                <SelectItem text="Choose an option" value="" />
                <SelectItem text="Pass" value="P" />
                <SelectItem text="Fail" value="F" />
            </Select>

            <p>
                Those who have not taken and passed the NCLEX or SBTPE are not
                eligible for multistate licensure and will be issued a single
                state license upon approval of their application
            </p>

            <div className="half-width-button-with-icon-group">
                <div className="half-width-button-with-icon-group-item">
                    <Button
                        className="fldoh-btn"
                        name={number}
                        type="button"
                        kind="danger"
                        size="md"
                        onClick={
                            handleSubtractAdditionalExaminationHistoryComponent
                        }
                    >
                        Remove
                        <Subtract />
                    </Button>
                </div>
            </div>
        </>
    )
}

export default AdditionalRegisteredNursingExaminationHistoryComponent
